<template>
  <div>
    <h3 class="pt-3 mb-2" :style="`color : ${wsDARKER}`">
      {{ $t(`avalon.config.fonts.edit_headings`) }}
    </h3>

    <font-family-select
        @input="checkConfigChanged(true)"
        v-model="$store.state.avalon.config.fonts.headings.family"
    />
    <font-param-select
        @input="checkConfigChanged"
        v-model="$store.state.avalon.config.fonts.headings.weight"
        :family="$store.state.avalon.config.fonts.headings.family"
    />
    <font-param-select
        @input="checkConfigChanged"
        v-model="$store.state.avalon.config.fonts.headings.style"
        font-style
    />

    <a-parameter-slider
        @input="checkConfigChanged"
        v-model="$store.state.avalon.config.fonts.headings.lineHeight"
        style="width: 100%"
        :track-color="wsDARKLIGHT"
        :value-color="wsACCENT"
        label="avalon.config.fonts.line_height"
        min="90"
        max="300"
        unit="%"
        light
    />

    <a-parameter-slider
        @input="checkConfigChanged"
        v-model="$store.state.avalon.config.fonts.headings.spacing"
        style="width: 100%"
        :track-color="wsDARKLIGHT"
        :value-color="wsACCENT"
        label="avalon.config.fonts.letter_spacing"
        min="0"
        max="50"
        light
    />

    <font-param-select
        @input="checkConfigChanged"
        v-model="$store.state.avalon.config.fonts.headings.case"
        font-case
    />

    <div v-for="(screenSize , i) in ['','_sm']" :key="i">
      <h4 class="pt-7 pb-2" :style="`color : ${wsDARKER}`">
        {{ $t(`Sizes` + screenSize) }}
      </h4>
      <a-parameter-slider
          v-for="size in ['h1','h2','h3','h4','h5']" :key="i + size"
          @input="checkConfigChanged"
          v-model="$store.state.avalon.config.fonts.headings.size[size + screenSize]"
          style="width: 100%"
          :track-color="wsDARKLIGHT"
          :value-color="wsACCENT"
          :label="`font.${size}`"
          min="10"
          max="100"
          light
      />
    </div>

  </div>
</template>

<script>
import fontFamilySelect from "@/components/AvalonEditor/UI/sidebar/fonts/UI/fontFamilySelect";
import fontParamSelect from "@/components/AvalonEditor/UI/sidebar/fonts/UI/fontParamSelect";
export default {
  name: "fontsSettingsHeading",
  components : {
    fontFamilySelect,
    fontParamSelect
  },
  methods : {
    checkConfigChanged(checkFonts) {
      this.$store.state.avalon.configChanged = true
      if (checkFonts) {
        this.CHECK_CONFIG_FONTS()
      }
    }
  },
  beforeMount() {
    this.CHECK_CONFIG_PARAM('fonts','families')
    this.CHECK_CONFIG_PARAM('fonts','headings')
    this.$store.state.avalon.initialConfigData = this.COPY(this.SITE_CONFIG)
  }
}
</script>

<style scoped>

</style>